<template>
    <div v-if="products">
        <h2 :class="{'section-title': stylizeTitle}">
            {{title}}
        </h2>
        <ProductList
                :products="products"
                :item-options="itemOptions"
                event-name="Última camisetas lançadas home"
                :list-class="`product-horizontal-list product-horizontal-list-${quantity} no-scrollbar`"
                @scroll="scrollEvent = $event"/>
        <HorizontalScrollbar
            class="hidden-not-touch"
            :scroll-event="scrollEvent"/>
    </div>
</template>

<script>
    import ProductList from "../common/ProductList";
    import HorizontalScrollbar from "../common/container/HorizontalScrollbar";

    export default {
        name: "HomeWholesalerHighlights",

        components: {HorizontalScrollbar, ProductList},

        props: {
            title: {
                type: String,
                required: true
            },
            quantity: {
                type: Number,
                required: true
            },
            type: {
                type: String,
                required: true
            },
            stylizeTitle: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                scrollEvent: null,
                products: null,
                itemOptions: {
                    hideInstallments: true,
                    displayPercent: false
                },
            }
        },

        created() {
            this.fetch();
        },

        methods: {
            fetch() {
                this.axios.http.get("/phpexe/_get_products_home_wholesalers.php", {params: {type: this.type}})
                    .then((response) => {
                        if (response.data) this.products = response.data.slice(0, this.quantity);
                    })
                    .catch(error => console.error(error));
            },
        }
    }
</script>